var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useBuildStyleWithTheme } from '@cvent/carina-theme-provider';
import iconTypes from './StepIconTypes';
var buildStyle = function (_a) {
    var font = _a.font, backgroundColor = _a.backgroundColor, size = _a.size, borderColor = _a.borderColor;
    return {
        iconWrapper: {
            base: {
                width: 24,
                height: 24,
                backgroundColor: backgroundColor.accent.fill.base,
                borderRadius: size.border.radius.round,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                pointerEvents: 'none',
                fontSize: font.base.size.h6
            },
            processing: {
                backgroundColor: backgroundColor.base
            },
            completed: {
                backgroundColor: font.color.fill
            },
            error: {
                backgroundColor: backgroundColor.base
            },
            incomplete: {
                backgroundColor: backgroundColor.base
            },
            selected: {
                backgroundColor: font.color.base
            }
        },
        main: {
            base: {
                display: 'flex',
                alignItems: 'center',
                width: '100%',
                height: '100%',
                justifyContent: 'center',
                fontSize: font.base.size.h5,
                borderRadius: size.border.radius.round,
                boxSizing: 'border-box' // fix for ovalish icons
            },
            incompleteSelected: {
                color: font.color.fill
            },
            partiallyCompleted: {
                border: "4px solid " + backgroundColor.accent.fill.base
            },
            partiallyCompletedHover: {
                border: "4px solid " + backgroundColor.accent.fill.focus
            },
            active: {
                backgroundColor: backgroundColor.accent.fill.base,
                color: font.color.fill
            },
            completed: {
                border: "2px solid " + backgroundColor.accent.fill.base
            },
            incomplete: {
                color: font.color.base,
                border: "1px solid " + borderColor.base
            },
            incompleteHover: {
                border: "1px solid " + font.color.soft
            },
            disabled: {
                backgroundColor: borderColor.base
            },
            disabledHover: {
                backgroundColor: font.color.soft
            }
        }
    };
};
var useStyle = function (_a) {
    var isSelected = _a.isSelected, status = _a.status, hover = _a.hover;
    var builtStyle = useBuildStyleWithTheme(buildStyle);
    if (!builtStyle) {
        return {
            iconWrapper: {},
            main: {}
        };
    }
    var iconWrapper = builtStyle.iconWrapper, main = builtStyle.main;
    return {
        iconWrapper: __assign(__assign(__assign(__assign(__assign(__assign({}, iconWrapper.base), (status === iconTypes.processing && iconWrapper.processing)), (status === iconTypes.completed && iconWrapper.completed)), (status === iconTypes.error && iconWrapper.error)), (status === iconTypes.incomplete &&
            !isSelected &&
            iconWrapper.incomplete)), (status === iconTypes.incomplete && isSelected && iconWrapper.selected)),
        main: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, main.base), (status === iconTypes.active && main.active)), (status === iconTypes.partial && main.partiallyCompleted)), (status === iconTypes.partial &&
            hover &&
            main.partiallyCompletedHover)), (status === iconTypes.completed && main.completed)), (status === iconTypes.incomplete && !isSelected && main.incomplete)), (status === iconTypes.incomplete &&
            isSelected &&
            main.incompleteSelected)), (status === iconTypes.incomplete && hover && main.incompleteHover)), (status === iconTypes.disabled && main.disabled)), (status === iconTypes.disabled && hover && main.disabledHover))
    };
};
export default useStyle;
